import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import type { Cinema } from "../cinema-module/cinema";
import { createLogger } from "utils/logging";

const log = createLogger("cinema", "pdp");

export class PdpCinema {
	constructor(private readonly cinema: Cinema) {}

	init() {
		/*                          */
		eventQBus.on("ft5.components.reload", () => {
			this.cinema.setSendTracking(true);
			log.info("Initialize PdpCinema");
			eventQBus.emit("pattern.carousel.init", ".ft9_benefit_cinema__cinema_module");
		});
	}
}
